<template>
  <router-view></router-view>
</template>

<script>
import { getUserToken } from "@/storage/memoryStorage";

export default {
  computed: {
    isConnected() {
      return this.$store.getters.isConnected;
    }
  },

  watch: {
    isConnected: function(newStatus, oldStatus) {
      if (newStatus) {
        this.accuTestSubscribe(true);
      }
    }
  },

  methods:{
    accuTestSubscribe: function(subscribe) {
      const stateSubscribe = {
        userToken: getUserToken(),
        accutest: subscribe
      };
      this.$socket.send(JSON.stringify(stateSubscribe));
    },
  },

  mounted() {
    if (this.isConnected) {
      this.accuTestSubscribe(true);
    }
  },

  beforeDestroy() {
    try {
      this.accuTestSubscribe(false);
    } catch (err) {
      //console.log("Unable send unsubscribe from live data");
    }
  }
};
</script>
